"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeBenefits = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../../hooks");
var _context = require("../../context");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubscribeBenefits = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    isBrandPartner
  } = (0, _context.useSubscriptionModule)();
  // Use different benefits for Brand Partners
  const benefits = (isBrandPartner ? translations.subscribeBenefitsBrandPartner : translations.subscribeBenefits).split(';').filter(Boolean);
  if (benefits.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.SUBSCRIBE_BENEFITS),
    children: benefits.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Item, {
      "data-testid": getTestId(_constants.SUBSCRIBE_BENEFIT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {}), benefit]
    }, benefit))
  });
};
exports.SubscribeBenefits = SubscribeBenefits;
